import { createSelector } from "reselect";

/**
 * selector to determine if patient overview orders is enabled
 */
export const patientOverviewOrdersEnabledSelector = createSelector(() => false);
